'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { PolicyFormScreen } from '../../-components/PolicyFormScreen';
export const Route = createFileRoute('/_staff/settings/notification-and-response/notification-policies/$policyId/edit/')({
  component: NotificationPolicyEdit
});
function NotificationPolicyEdit() {
  const {
    policyId
  } = Route.useParams();
  return <PolicyFormScreen policyId={policyId} mode="edit" />;
}